<div class="modal-background" *ngIf="isVisible">
  <div class="modal">
    <h2>{{ title }}</h2>
    <p>{{ content }}</p>
    <button (click)="close()">Close</button>
  </div>
</div>
